import '../../components.theme/layout-search/layout-search';

window.layoutSearchHighlight = false;
